import React from 'react';

const EventsSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {[...Array(8)].map((_, index) => (
        <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
          {/* Image skeleton */}
          <div className="h-48 bg-gray-200"></div>
          
          {/* Content skeleton */}
          <div className="p-6">
            {/* Title */}
            <div className="h-6 bg-gray-200 rounded-lg mb-3"></div>
            
            {/* Location */}
            <div className="flex items-center mb-2">
              <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
            
            {/* Date */}
            <div className="flex items-center mb-4">
              <div className="h-4 w-4 bg-gray-200 rounded mr-2"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
            
            {/* Bottom row */}
            <div className="flex justify-between items-center">
              <div className="h-6 bg-gray-200 rounded-full w-20"></div>
              <div className="h-8 bg-gray-200 rounded-lg w-24"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventsSkeleton;